module.exports = __webpack_public_path__ + "img/banner-1.3c637ec3.jpg";